import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Button } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import styles from './SMLEmptyState.module.scss';

interface SMLEmptyStateAction {
  label: string;
  onClick: () => void;
}

interface SMLEmptyStateProps {
  icon: IconDefinition;
  title: string;
  description?: string;
  action?: SMLEmptyStateAction;
}

const SMLEmptyStateComponent: React.FC<SMLEmptyStateProps> = ({ icon, title, description, action }) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <FontAwesomeIcon icon={icon} className={styles.icon} />
      </div>
      <h3 className={styles.title}>{title}</h3>
      {description !== undefined && <p className={styles.description}>{description}</p>}
      {action !== undefined && (
        <Button color="primary" size="sm" className={styles.action} onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
};

export const SMLEmptyState = TypedMemo(SMLEmptyStateComponent);
